import {Routes} from '@angular/router';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {PortalService} from '../services/portal.service';
import {StepChapterComponent} from '../step/step.chapter.component';
import {EingabeStartComponent} from './eingabe/eingabe.start.component';
import {EingabeStepComponent} from './eingabe/eingabe.step.component';
import {ErgebnisComponent} from './ergebnis/ergebnis.component';
import {EingabeStepVerbrauchsdatenComponent} from './eingabe/eingabe.step.verbrauchsdaten.component';
import {EinstiegComponent} from "./einstieg/einstieg.component";
import {KopfbuehneComponent} from "./kopfbuehne/kopfbuehne.component";

/**
 * Routes for the stromcheck.
 * The default route leads to stromcheck here
 */
const routes: Routes = [
  {
    path: ':portalId/stromcheck', children: [
      // default step is 'eingabe'
      {path: '', redirectTo: 'start', pathMatch: 'full'},
      // list of all available steps in the advisor
      // first input section
      {path: 'kurz', component: EinstiegComponent},
      {path: 'kopfbuehne', component: KopfbuehneComponent},
      {path: 'start', component: EingabeStartComponent},
      {path: 'eingabe/start', redirectTo: 'start', pathMatch: 'full'},

      {
        path: 'eingabe', component: StepChapterComponent, children: [
          {path: 'basisinformationen/1', component: EingabeStepComponent, data: {swipeCount: '20'}},
          {path: 'basisinformationen/2', component: EingabeStepComponent, data: {swipeCount: '30'}},
          {path: 'basisinformationen/3', component: EingabeStepComponent, data: {swipeCount: '40'}},
          {path: 'basisinformationen/4', component: EingabeStepComponent, data: {swipeCount: '50'}},
          {path: 'basisinformationen/5', component: EingabeStepComponent, data: {swipeCount: '60'}},
          {path: 'basisinformationen/6', component: EingabeStepComponent, data: {swipeCount: '70'}},
          {path: 'basisinformationen/7', component: EingabeStepComponent, data: {swipeCount: '80'}},
          {path: 'verbrauchsdaten', component: EingabeStepVerbrauchsdatenComponent, data: {swipeCount: '90'}},
          {path: '', redirectTo: 'basisinformationen/1', pathMatch: 'full'},
        ]
      },
      // last section with result page
      {
        path: 'ergebnis', component: StepChapterComponent, children: [
          {path: 'analyse', component: ErgebnisComponent, data: {swipeCount: '1000', advisor: 'stromcheck'}},
          {path: '', redirectTo: 'analyse', pathMatch: 'full'},
        ]
      },
    ]
  },
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/stromcheck', pathMatch: 'full'},
  {path: 'stromcheck/', redirectTo: PortalService.defaultPortal + '/stromcheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/stromcheck', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class StromcheckRoutingModule {
}
